{
  "breadcrumbs": {
    "financialProducts": {
      "index": "$t(common:labels.financialProducts)",
      "detail": "$t(clientLifecycle:labels.productDetailsSummary)",
      "edit": "Edit Financial Product",
      "ledgerConfiguration": "Ledger Configuration",
      "createLedgers": "Create Ledgers",
      "ledgerDetail": "$t(common:labels.ledgerDetails)"
    },
    "instrumentProducts": {
      "index": "$t(common:labels.instrumentProducts)",
      "detail": "$t(clientLifecycle:labels.productDetailsSummary)",
      "edit": "Edit Instrument Product"
    },
    "clients": {
      "index": "$t(clientLifecycle:labels.clients)",
      "add": "$t(clientLifecycle:labels.addNewClient)",
      "detail": "$t(clientLifecycle:labels.clientDetails)",
      "edit": "$t(clientLifecycle:labels.editClient)"
    },
    "subClients": {
      "index": "$t(common:labels.subClients)",
      "add": "Add New Sub Client",
      "detail": "Sub Client Details",
      "edit": "$t(clientLifecycle:labels.editClient)"
    },
    "accountHolders": {
      "index": "Account Holders",
      "create": "Create Customer"
    },
    "offsetAccounts": {
      "detail": "{{accountType}}"
    },
    "addNewFinancialProduct": {
      "index": "Add New Financial Product"
    },
    "addNewInstrumentProduct": {
      "index": "Add New Instrument Product"
    }
  },
  "modals": {
    "saveChangesTitle": "Save changes?",
    "saveChangesContent": "You are about to save your changes. These updates may affect how things work moving forward. Are you sure you want to continue?",
    "discardChangesTitle": "Discard unsaved changes?",
    "discardChangesContent": "You have unsaved changes. If you proceed, your changes will be lost. Are you sure you want to discard them?"
  },
  "buttons": {
    "discardChanges": "Discard changes",
    "keepEditing": "Keep editing"
  },
  "labels": {
    "productDetailsSummary": "Product Details - Summary",
    "editClient": "Edit Client",
    "clientDetails": "$t(common:labels.clientDetails)",
    "companyAddress": "Company Address",
    "businessAddress": "Business Address",
    "brandName": "Brand Name",
    "contactEmail": "$t(common:labels.contactEmail)",
    "contactName": "$t(common:labels.contactName)",
    "businessName": "Business Name",
    "aliasName": "Alias Name",
    "contactPhone": "Contact Phone",
    "baseCurrency": "$t(clientLifecycle:components.usage.baseCurrency)",
    "issuingPartner": "Issuing partner",
    "service": "Service",
    "bin": "BIN",
    "membershipId": "Membership ID",
    "unitedKingdom": "United Kingdom",
    "issuerCode": "Issuer Code",
    "issuerName": "Issuer Name",
    "primaryPhone": "Primary Phone",
    "secondaryPhone": "Secondary Phone",
    "rulesetType": "Ruleset Type",
    "searchByName": "Search by Name",
    "clientName": "$t(common:labels.clientName)",
    "subClient": "Sub Client",
    "reportingCurrency": "Reporting Currency",
    "reportingCutoffTime": "Reporting Cutoff Time",
    "reportingTimezone": "Reporting Timezone",
    "clients": "$t(common:components.mainMenu.clients)",
    "searchByNameOrReferenceNumber": "Search by Name or Reference Number",
    "addNewClient": "Add New Client",
    "addTransactionType": "Add Transaction Type",
    "addTransactionRule": "Add Transaction Rule",
    "editTransactionRule": "Edit Transaction Rule",
    "channelName": "Channel Name",
    "rejectionRule": "Rejection Rule",
    "sourceType": "Source Type",
    "channelType": "Channel Type",
    "bucketConfig": "Bucket Configuration",
    "bucketConfigSub": "Create Buckets for Credit Products",
    "bucketTransactionType": "Transactions Type",
    "balanceLimitDeciderTitle": "Balance Limit Decider",
    "balanceLimit": {
      "FIXED_AMOUNT": "Fixed amount",
      "GREATER_OF": "Greater of",
      "LESSER_OF": "Lesser of"
    },
    "bucketDefault": "Default",
    "bucketDefaultTier": "DEFAULT",
    "period": "Period",
    "selectPeriod": "Select Period",
    "bucketInterestTitle": "Configure Bucket Interest",
    "bucketInterestSubtitle": "Assign APR to individual buckets",
    "tier": "Tier {{index}}",
    "bucketInterestTiers": "Bucket Interest Tiers",
    "modifyBucketInterestTiers": "Modify Bucket Interest Tiers",
    "addTier": "Add Tier",
    "removeTier": "Remove Tier",
    "pinControlled": "Pin Controlled",
    "nonPinControlled": "Non Pin Controlled",
    "interval": "Interval",
    "hardDecline": "Hard Decline",
    "softDecline": "Soft Decline",
    "doNothing": "Do Nothing",
    "highestInterestFirst": "Highest Interest First",
    "purchasesFirst": "Purchases First",
    "cashFirst": "Cash First",
    "notAllowed": "$t(common:labels.notAllowed)",
    "cashOnly": "Cash Only",
    "purchaseOnly": "Purchase Only",
    "cashAndPurchase": "Cash & Purchase",
    "enableContactlessConfiguration": "Enable Contactless Configuration",
    "enablePinConfiguration": "Enable PIN Configuration",
    "deactivated": "Deactivated",
    "virtualAndPhysical": "Virtual & Physical",
    "networkDetails": "Network Details",
    "countryOfIssue": "Country of Issue",
    "scheme": "Service (Scheme)",
    "schemeMembershipId": "ICA (Scheme Membership ID)",
    "selectCurrency": "Select a currency",
    "productCategory": {
      "debit": "$t(common:labels.debit)",
      "credit": "$t(common:labels.credit)"
    },
    "pinOptions": {
      "type": {
        "autoGenerated": "Auto Generated",
        "selfService": "Self Service"
      },
      "level": {
        "bin": "$t(instrumentIssuance:components.keyManagementData.bin)",
        "binRange": "Bin Range"
      },
      "bureau": {
        "externalProvider": "External Provider"
      },
      "algorithm": {
        "visa": "VISA",
        "ibm3624": "IBM3624"
      }
    },
    "basicInformation": "$t(common:labels.basicInformation)",
    "selectFinancialProductsToChooseLedgers": "Select financial products to choose ledgers",
    "noLedgersAvailableForProduct": "No ledgers available for this product",
    "selectFinancialProduct": "Select Financial Product",
    "searchByFinancialProduct": "Search by Financial Product",
    "searchByLedger": "Search by Ledger",
    "linkedLedgers": "Linked Ledgers",
    "offset": "Offset",
    "selectFiltersToSeeOffsetAccounts": "Select Client, Sub-Client, Currency and Date to see the Offset Accounts.",
    "selectCurrencyAndDateToSeeOffsetAccounts": "Select Currency and Date to see Offset Accounts.",
    "institution": "Institution",
    "programManagerCode": "Program Manager Code",
    "folderName": "Folder Name",
    "fileName": "File Name",
    "issuerVersionFileName": "Issuer Version File Name",
    "verify": "Verify",
    "advancePermission": "Advance Permission",
    "xmlFilePrefix": "XML File Prefix",
    "xmlSchemeId": "Issuer Scheme ID",
    "schemeMaster": "Scheme Master",
    "bank": "Bank",
    "filePrefix": "File Prefix",
    "bankMaster": "Bank Master",
    "chargeback": "Chargeback",
    "timezone": "Timezone",
    "groupLimit": "Group Limit",
    "si": "SI",
    "showHistory": "Show History",
    "mccCode": "MCC Code",
    "groupUsageCode": "Group Usage Code",
    "allow": "Allow",
    "cardAcceptorList": "Card Acceptor List",
    "cardDisallowList": "Card Disallow List",
    "ehiBalance": "EHI Balance",
    "returnBalanceAsSumOf": "Return Balance as sum of",
    "clientCategory": "Client Category"
  },
  "mccPadding": {
    "paddingAmount": "Padding Amount (%)"
  },
  "xmlFileDetails": {
    "xmlFileDetails": "XML File Details",
    "issuerFile_QM": "Issuer File?",
    "selectIssuerFile": "Select Issuer File",
    "issuerFilePrefix": "Issuer File Prefix",
    "xmlWalletSchemeId": "Issuer Wallet Scheme ID",
    "showPublicToken_QM": "Show Public Token",
    "fileFormat": "File Format"
  },
  "webServiceFeeMaster": {
    "webServiceFeeMaster": "Web Service Fee Master",
    "searchByCode": "Search by Code",
    "searchByInstitution": "Search by Institution",
    "searchByDescription": "Search by Description"
  },
  "feesMaster": {
    "feesMaster": "Fees Master",
    "feeName": "Fee Name",
    "feeCreatedDate": "Fee Created Date",
    "amountOfFee": "Amount of Fee",
    "messageText": "Message Text",
    "feeType": "Fee Type"
  },
  "fraudAndRiskConfigurations": {
    "fraudAndRiskConfigurations": "Fraud & Risk Configurations",
    "schemePlaceholder": "Select scheme",
    "selectAllProducts": "Select all products",
    "clearProductSelection": "Clear selection",
    "writeOnlyNote": "Note: Please note that this screen will not display the existing Fraud and Risk Configuration of the products. Any changes made here will overwrite the existing configurations of the products.",
    "fraudManagerOptions": {
      "fraudManagerNotUsed": "0 - FM not used",
      "fraudManagerStandard": "1 - Fraud Manager standard",
      "fraudManagerAdvanced": "2 - Fraud Manager advanced"
    }
  },
  "webServiceFeesByGroup": {
    "webServiceFeesByGroup": "Web Service Fees",
    "subtitle": "Configure web service fee rules for a fee group.",
    "isLive": "Is Live"
  },
  "recurringFeeSubGroupMaster": {
    "recurringFeeSubGroupMaster": "Recurring Fee Sub Group Master",
    "feeSubGroupName": "Fee Sub Group Name",
    "feeNote": "Fee Note"
  },
  "groupFeeRecurringMaster": {
    "groupFeeRecurringMaster": "Group Fee Recurring Master",
    "subtitle": "Create and manage group fee recurring master records.",
    "pendingFeesEnabled": "Pending Fees Enabled"
  },
  "groupRecurringFees": {
    "groupRecurringFees": "Group Recurring Fees",
    "feeGroup": "Fee Group",
    "recurringFee": "Recurring Fee",
    "feeAmount": "Fee Amount",
    "freq": "Freq",
    "repeatEvery": "Repeat Every",
    "feeGroupCode": "Fee Group Code",
    "feeStartDate": "Fee Start Date",
    "feeEndDate": "Fee End Date",
    "lowActivityAmount": "LowActivity Amount",
    "freqPeriod": "Freq Period",
    "repeatPeriod": "Repeat Period"
  },
  "feesByGroup": {
    "feesByGroup": "Fees by Group",
    "subtitle": "Configure basic or advanced geographical authorization fee rules for a fee group.",
    "tabBasic": "Basic Auth Fees",
    "tabAdvGeo": "Adv/Geo Auth Fees",
    "tabBasicHint": "Standard domestic, non-domestic, and FX fee fields with optional currency and cap rules.",
    "tabAdvGeoHint": "Geography and currency-scenario blocks, decline statuses, and bespoke currency pairs.",
    "excludeAids": "Exclude AIDs for the Fee Group",
    "thresholdAmt": "Threshold Amt",
    "smsFee": "SMS Fee",
    "freeTranPerMonth": "No of Free Tran / Month",
    "freeTranPerActivation": "No of Free Tran / Activation",
    "allowMultipleFees": "Allow Multiple Fees",
    "partialAllowed": "Partial Allowed",
    "domFee": "Dom Fee",
    "domFeeRatePct": "Dom Fee rate in %",
    "nonDomFee": "Non Dom Fee",
    "nonDomFeeRatePct": "Non Dom Fee Rate in %",
    "nonDomMinFee": "Non Dom Min Fee",
    "domMinFee": "Dom Min Fee",
    "declineFee": "Decline Fee",
    "fxFixed": "Fx Fixed",
    "fxRatePct": "Fx Rate in %",
    "fxMinFee": "Fx Min Fee",
    "capDomFeeRate": "Cap Dom Fee Rate in Currency",
    "capNonDomFeeRate": "Cap Non Dom Fee Rate in Currency",
    "capFxFeeRate": "Cap Fx Fee Rate in Currency",
    "nonDomRateHint": "Enter percentage as a number (e.g. 1.75% → 1.75).",
    "selectedGroup": "Selected Group — {{group}}",
    "enableCurrencyCheck": "Enable Currency Check",
    "declineStatuses": "Decline Statuses",
    "declineStatusesModalTitle": "Decline statuses",
    "bespokeCurrencyPairs": "Bespoke Currency Pairs",
    "geoBlockDomesticNonBase": "Domestic & Non-Base Currency",
    "geoBlockNonDomesticBase": "Non-Domestic & Base Currency",
    "geoBlockNonDomesticNonBase": "Non-Domestic & Non-Base Currency",
    "feeRatePct": "Fee Rate in %",
    "minFee": "Min Fee",
    "capFee": "Cap Fee",
    "colProcCode": "Proc Code",
    "colCcy": "CCY",
    "colDomFeeRatePct": "Dom Fee Rate (in %)",
    "colNonDomRatePct": "Non Dom Rate (in %)",
    "colThresholdType": "Threshold Type",
    "colCapDomFee": "Cap Dom Fee",
    "colNoFreeTran": "No Of Free Tran",
    "colNoFreeTranActivation": "No Of Free Tran/Activation",
    "colDomNoCcyFee": "DomNoCcy Fee",
    "colDomNoCcyRate": "DomNoCcy Rate",
    "colDomNoCcyMinFee": "DomNoCcy MinFee",
    "colDomNoCcyRateCap": "DomNoCcy RateCap"
  },
  "bankMaster": {
    "summaryReportFormat": "Summary Report Format",
    "createdDate": "Created Date",
    "destinationFolder": "Destination Folder",
    "safeReportDestination": "SAFE Report Destination",
    "visaMasterCardReportReq": "Visa/MasterCard Monthly/Quarterly Reporting Requirements",
    "xmlCutoffUTCTime": "XML Cutoff UTC Time",
    "feeCollectionReport": "Fee Collection Report"
  },
  "bank": {
    "bankDetails": "Bank Details",
    "bankCode": "Bank Code",
    "bankName": "Bank Name",
    "memberId": "Member ID",
    "memberName": "Member Name",
    "vssReportPath": "VSS Reporting Path",
    "visaSegmentId": "Visa Segment ID",
    "visaNcnId": "Visa NCN ID",
    "clientEmail": "Client Email",
    "showBin": "Show BIN",
    "hiddenBin": "********"
  },
  "institutionExport": {
    "institutionExport": "Institution Export",
    "chooseInstitution": "Choose Institution for export",
    "chooseSchemeBank": "Choose Scheme - Bank",
    "exportSuccess": "Export successful",
    "exportSuccessDescription": "Exported data for {{institution}} - {{schemeBank}}"
  },
  "productMaster": {
    "productMaster": "Product Master",
    "generalSettings": "General Settings",
    "additionalGeneralSettings": "Additional General Settings",
    "advanceSettings": "Advance Settings",
    "riskManagement": "Risk Management",
    "keyConfigurations": "Key Configurations",
    "activeFlag": "Active Flag",
    "saveGeneralSettings": "Save General Settings",
    "saveAdditionalGeneralSettings": "Save Additional General Settings",
    "saveAdvanceSettings": "Save Advance Settings",
    "saveEhiSettings": "Save EHI Settings",
    "saveRiskManagementSettings": "Save Risk Management Settings",
    "removeEhiConfiguration": "Remove EHI Configuration",
    "showKeys": "Show Keys",
    "duplicate": "Duplicate",
    "programId": "Program ID",
    "embossName": "Emboss Name",
    "subBinLow": "SubBin Low",
    "subBinHigh": "SubBin High",
    "sbRangeLow": "SBRange Low",
    "sbRangeHigh": "SBRange High",
    "hangingFilterNormalAuths": "Hanging filter - normal auths (In days)",
    "hangingFilterPreAuths": "Hanging filter - pre-auths (days)",
    "authIdResponse": "AuthID Response (DE38)",
    "limitedNetwork": "Limited Network",
    "applyBreakageFeeOnExpiry": "Apply Breakage Fee on Expiry",
    "shortNameSms": "Short Name SMS",
    "cardAccountNonExpiry": "Card Account Non expiry",
    "separateCardFile": "Separate Card File",
    "autoCreditChargeback": "Auto credit chargeback",
    "noDebitSecondPresentment": "No Debit Second Presentment",
    "networkId": "Network ID",
    "dgnIicDxsCode": "DGN IIC DXS Code",
    "dgnIicIsoCode": "DGN IIC ISO Code",
    "subNetwork": "Sub Network",
    "alwaysReturnUncheckedForAvs": "Always return 'Unchecked' for AVS",
    "consumerNonReloadablePrepaid": "Consumer Non-Reloadable Prepaid Account Range",
    "consumerSingleUseVirtualCard": "Consumer Single Use Virtual Card Product",
    "groupUsage": "Group Usage",
    "groupAuthFee": "Group AuthFee",
    "groupMcc": "Group MCC",
    "groupRecurring": "Group Recurring",
    "groupWebService": "Group Web Service",
    "groupLinkage": "Group Linkage",
    "fxGroups": "FX Groups",
    "calendarGroup": "Calendar Group",
    "crdProduct": "CRD Product",
    "threddFevValidity": "Thredd/FEV Validity",
    "countryOfIssue": "Country Of Issue",
    "settlementCurrency": "Settlement Currency",
    "fxPaddingAmount": "FX Padding Amount (%)",
    "cardPhysicalLayout": "Card Physical Layout",
    "allowAutomaticCardGeneration": "Allow Automatic Card Generation",
    "archiveTransactionsAfter": "Archive Transactions After",
    "qrCode": "QR Code",
    "imageTemplate": "Image Template",
    "ccaProcessing": "CCA (DE111) Processing",
    "sendAlertPercentage": "Send alert while percentage of the card remains",
    "sendAlertNumberOfCards": "Send alert while number of cards less than",
    "restockQuantity": "Restock Quantity",
    "mailSettings": "Mail Settings",
    "messageAlertSettings": "Message Alert Settings",
    "networkProductCode": "Network Product Code",
    "dynamicInterchangeDisabled": "Dynamic Interchange Disabled",
    "multicurrencySettlement": "Multicurrency Settlement",
    "currentSettlementCurrency": "Current Settlement Currency",
    "singleCurrencySettlement": "Single Currency Settlement",
    "multiCurrencySettlement": "Multi Currency Settlement",
    "currencyList": "Currency List",
    "configuredSettlementCurrencies": "Configured Settlement Currencies",
    "disableMultiCurrencySettlement": "Disable Multi Currency Settlement",
    "contactlessTrack2": "Contactless Track2",
    "track2AtcLength": "Track2 ATC Length",
    "track2CvvLength": "Track2 CVV Length",
    "track2UnLength": "Track2 UN Length",
    "position": "Position",
    "atcBitMap": "ATC BitMap",
    "cvvBitMap": "CVV BitMap",
    "unBitMap": "UN BitMap",
    "sampleTrack2Format": "Sample Track2 Format",
    "fxMode": "FX Mode",
    "productCurrency": "Product Currency",
    "dataModelVersion": "Data Model Version",
    "sessionKeyDerivationMethod": "Session Key Derivation Method for Contact and Contactless Cards",
    "arpcKey": "ARPC Key",
    "threddBillingRef": "Thredd Billing Ref",
    "minInitialPinLength": "Min/Initial Pin Length",
    "maxPinLength": "Max Pin Length",
    "serviceEnhancementIndicator": "Service Enhancement Indicator",
    "servicePrompt": "Service Prompt",
    "paymentTokenUsage": "Payment Token Usage",
    "cvc2MaxTries": "CVC2 Max Tries",
    "psd2Compliance": "PSD2 Compliance",
    "psd2TxnCountLimit": "PSD2 Txn Count Limit",
    "psd2AccumValueLimit": "PSD2 Accum Value Limit",
    "psd2SingleValLimit": "PSD2 Single Val Limit",
    "psd2TxnRiskAnalysisMaxExemption": "PSD2 Txn Risk Analysis Max exemption value",
    "psd2AcquirerLowValueMaxExemption": "PSD2 Acquirer Low-Value Max exemption value",
    "threeDsIsSCAOnlyIfCardholderChallenged": "3DS is SCA only if cardholder challenged",
    "recurringPaymentOriginalMustBeSCA": "Recurring payment original must be SCA",
    "exemptPanKeyEntryFromHotel": "Exempt PAN key entry from Hotel",
    "exemptPanKeyEntryFromVehicleRental": "Exempt PAN key entry from Vehicle Rental",
    "whenAuthHigherThanAuth": "When Authorisation Amount is Higher than Authentication Amount by",
    "lessThanOrEqualTo20": "Less than or equal to 20%",
    "moreThan20": "More than 20%",
    "currencyMismatch": "Currency mismatch",
    "ecommerce": "E-commerce",
    "ehiGroup": "EHI Group",
    "mode": "Mode",
    "includeDeclinedAuthorisations": "Include Declined Authorisations",
    "standIn": "Stand In",
    "approveWithLoad": "Approve With Load",
    "delaySend": "Delay Send",
    "balanceStandIn": "Balance Stand IN",
    "stipOnTimeout": "STIP on timeout",
    "overdraftLimit": "OverDraft Limit",
    "transactionTypes": "Transaction Types",
    "authorisation": "Authorisation",
    "financial": "Financial",
    "loadUnload": "Load/Unload",
    "balAdjustExpiry": "Bal Adjust/Expiry",
    "authorisationAdvice": "Authorisation Advice",
    "tar": "TAR",
    "enableEhiFeed": "Enable EHI Feed",
    "fleetData": "Fleet Data",
    "internalIpLevel": "Internal IP Level",
    "ehiUrl": "EHI URL | Decisional URL",
    "informationalUrl": "Informational URL",
    "clearingUrl": "Clearing URL",
    "timeoutAfter": "Timeout After",
    "milliseconds": "Milliseconds",
    "drUrlActive": "DR URL-Active",
    "drEhiUrl": "DR_EHI_URL",
    "drCutOffUrl": "DR_CutOff_URL",
    "sslKey": "SSL Key",
    "repeatAfter": "Repeat After",
    "min": "Min",
    "for": "for",
    "times": "Times",
    "sendCutOffMessage": "Send Cut Off Message",
    "cutOffInterval": "Cut Off Interval",
    "hours": "Hours",
    "cutOffUrl": "Cut Off URL",
    "format": "Format",
    "pinKeyFile": "PIN Key File",
    "feederInstance": "Feeder Instance",
    "sendCvv2": "Send CVV2",
    "sendPin": "Send PIN",
    "sendExpiryDate": "Send Expiry Date",
    "sendPanSequenceNumber": "Send PAN Sequence Number",
    "mtls": "mTLS",
    "mtlsFileSecretId": "mTLS File SecretID",
    "mtlsPasswordSecretId": "mTLS Password SecretID",
    "threddProtect": "Thredd Protect",
    "threddProtectDataFeed": "Thredd Protect Data Feed",
    "fraudAdvantage": "Fraud Advantage",
    "threeDSecure": "3D Secure",
    "threeDsSupplier": "3DS Supplier",
    "threeDsVersion": "3DS Version",
    "fraudManager": "Fraud Manager",
    "fraudRealTimeFeature": "Fraud Real Time Feature",
    "cardDetailsUpdate": "Card Details Update",
    "days": "Days",
    "additionalFieldsRequired": "Additional fields are required for the selected Network ID",
    "noLongerUsed": "(No longer used)",
    "enableWebService": "Enable Web Service",
    "smsOtpAutoEnrolment": "SMS OTP Auto Enrolment",
    "biometricsAutoEnrolment": "Biometrics Auto Enrolment",
    "oobAutoEnrolment": "OOB Auto Enrolment",
    "threeDsAdditionalSettings": "3DS Additional Settings",
    "apataSettings": "Apata Settings",
    "financialInstitutionId": "Financial Institution ID",
    "challengeProfileId": "Challenge Profile ID",
    "kbaQuestionsToAnswer": "Number of KBA Questions to Answer",
    "kbaIncorrectPermissible": "Number of Incorrect Permissible for KBA",
    "cardinalSettings": "Cardinal Settings",
    "alternateSmsUrl": "Alternate SMS URL",
    "initialBiometricCredentialValue": "Initial Biometric Credential Value",
    "defaultAuthentication": "Default Authentication",
    "fallbackAuthentication": "Fallback Authentication",
    "biometricValidationTimeout": "Biometric Validation Timeout (seconds)",
    "initialOobCredentialValue": "Initial OOB Credential Value",
    "oobValidationTimeout": "OOB Validation Timeout (seconds)",
    "threddProtectFraudManagerConflict": "Both Thredd Protect Data Feed and Fraud Manager cannot be configured at the same time.",
    "archiveTransactionsMandateWarning": "(Thredd Mandate: 96 days)",
    "archiveTransactionsMandateTooltip": "Thredd Mandate: Do not deviate from 96 days or amend without Thredd approval."
  },
  "institutionMaster": {
    "institutionMaster": "Institution Master",
    "showUsersForInstitution": "Show Users For This Institution",
    "appendWitExistingPermission": "Append With Existing Permission",
    "updateAdvancedPermissionInstitutionLvlOnly": "Update Advanced Permissions at Institution Level Only",
    "updateAdvancedPermissionsInstitutionAndSchemeLvl": "Update Advanced Permission at Institution and Scheme Levels",
    "updateAdvancedPermissionsInstitutionSchemeCardLvl": "Update Advanced Permission at Institution, Scheme, and Card Levels",
    "checkPanLevelAdvPermissionForInstitution": "Check PAN Level Advanced Permission for this Institution",
    "projectManager": "Project Manager",
    "implementationManager": "Implementation Manager",
    "issuingProgramManagerDescription": "Issuing Program Manager Description",
    "loginName": "Login Name",
    "permissionsGroup": "Permissions Group",
    "lastAccessDate": "Last Access Date",
    "usersForInstitution": "Users For This Institution"
  },
  "schemeMaster": {
    "schemeName": "Scheme Name",
    "validityPeriod": "Validity Period (In Months)",
    "activation": "Activation",
    "accNoXmlRpt": "Account Number (XML Report)",
    "binRangeLow": "BIN Range Low",
    "billingProgramme": "Billing Programme",
    "magneticChip": "Magnetic/Chip",
    "schemeCode": "Scheme Code",
    "manufacturer": "Manufacturer",
    "binRangeHigh": "BIN Range High",
    "participatesInAutoBillingUpdater": "Participates in Automatic Billing Updater (MasterCard ABU/Visa VAU)"
  },
  "productExport": {
    "productExport": "Product Export",
    "exportToXml": "Export To XML",
    "loyaltySchemes": "Loyalty Schemes",
    "loadedSuccessfullyDataAvailable": "Loaded Successfully, Data Available",
    "loadedSuccessfullyNoData": "Loaded Successfully, No Data"
  },
  "productImport": {
    "productImport": "Product Import",
    "noDataToImport": "No Data to Import",
    "dataAlreadyExists": "Data Already Exists in Table",
    "table": "Table",
    "overwrite": "Overwrite",
    "uploadFailed": "Upload failed, please try again later",
    "draggerText": "Drag & Drop your XML File Here or Click to Browse"
  },
  "programManagerMaster": {
    "programManagerMaster": "Program Manager Master",
    "soapUserName": "SOAP User Name",
    "soapPassword": "SOAP Password",
    "sendImageInResponse": "Send Image In Response",
    "pgpKey": "PGP Key",
    "clientEmailAddress": "Client Email Address",
    "smsProvider": "SMS Provider",
    "scamDetect": "Scam Detect",
    "visaParticipantId": "Visa Participant ID",
    "balanceXMLAtIssuerCutOffTime": "Balance XML At Issuer Cut-Off Time",
    "7DayPresentmentProcessing": "7 Day Presentment Processing",
    "dynamicInterchangeEnabled": "Dynamic Interchange Enabled"
  },
  "offsetAccounts": {
    "introduction": "All transactions are double-entered so they offset each other: once in the customer account and once in one or more sub-client offset accounts. For each currency, the following offset accounts are created:",
    "accountTypes": {
      "loadsUnloads": "Loads and Unloads",
      "schemeSettlement": "Scheme Settlement",
      "interchangeRevenue": "Interchange Revenue",
      "clientFees": "Client Fees",
      "internalTransferSuspense": "Internal Transfer Suspense",
      "operationalLosses": "Operational Losses",
      "disputesSuspense": "Disputes Suspense",
      "pending": "Pending Transactions"
    },
    "descriptions": {
      "loadsUnloads": "For all customer funding and withdrawal channels.",
      "schemeSettlement": "For amounts payable to payment schemes for settlements (for example, Visa, Mastercard).",
      "interchangeRevenue": "For scheme revenue earned by the client.",
      "clientFees": "For client-specific fees that were charged to the customer.",
      "internalTransferSuspense": "For internal ledger transfers.",
      "operationalLosses": "For losses, including fraud and write-offs.",
      "disputesSuspense": "For disputed transactions pending resolution.",
      "pending": "For transactions waiting to be posted to the correct ledger."
    },
    "dateTooltip": "Select the required date. The latest available date is displayed by default"
  },
  "errors": {
    "updateFailed": "Update Failed",
    "pleaseCheckRequiredFields": "Please check the required fields",
    "endDateAfterStart": "Active end date should come after active start date.",
    "formFillRequiredFields": "Please fill all required fields",
    "formInputField": "Please input the",
    "genericErrorMessage": "Something went wrong, try again later",
    "productNameAlreadyExists": "A financial product with this name already exists. Please choose a different name.",
    "duplicateBucketIDError": "{{bucketId}} already exists, please choose another value",
    "decimalizationTableLength": "Decimalization table must be exactly 16 characters long.",
    "padCharacterLength": "Pad character must be exactly 1 character long.",
    "decimalizationTableDigitsOnly": "Decimalization table must only contain digits (0-9).",
    "mainPolicyUpdateFailed": "Main policy update failed",
    "oneOrMoreQuickActionsFailed": "One or more quick actions failed",
    "accountHolderCreateFailed": "Failed to create account holder",
    "accountHolderListRefreshFailed": "The account holder was created, but the account holder list could not be refreshed. Reload the page if they do not appear.",
    "wizardDataLoadFailed": "Failed to load the required data. Please try again.",
    "policyGroupCreationFailed": "Policy group creation failed",
    "policyGroupUpdateFailed": "Policy group update failed",
    "validationFailed": "Validation failed",
    "validation": {
      "invalidEmailFormat": "Invalid email format",
      "phoneNumberInvalidFormat": "Phone number must start with + (international) or 0 (UK domestic)",
      "phoneNumberTooShort": "Phone number is too short (min 10 characters)",
      "phoneNumberTooLong": "Phone number is too long (max 16 characters)",
      "phoneNumberOnlyDigits": "Phone number must contain only digits after + or 0",
      "fieldRequired": "{{fieldName}} is required",
      "fieldMinLength": "{{fieldName}} must be at least 2 characters",
      "programmeManagerCodeInvalidFormat": "Programme Manager Code must contain only letters and numbers",
      "programmeManagerIdInvalidFormat": "Programme Manager ID must contain only digits",
      "programmeManagerIdOutOfRange": "Programme Manager ID must be at most {{max}}"
    }
  },
  "messages": {
    "countryCurrencyError": "Failed to load country and currency information. Please try again later.",
    "mccFetchError": "Failed to load merchant category codes. Please try again later.",
    "transactionRuleCreateSuccess": "Transaction Rule has been created",
    "transactionRuleUpdateSuccess": "Transaction Rule has been updated",
    "channelRulesCreateSuccess": "Channel Rule has been created",
    "channelRulesUpdateSuccess": "Channel Rule has been updated",
    "clientCreateSuccess": "Client has been created",
    "clientUpdateSuccess": "Client has been updated"
  },
  "notifications": {
    "bucketDeletedSuccess": "Successfully deleted Bucket",
    "bucketDefaultChanged": "Successfully changed default Bucket"
  },
  "components": {
    "tabs": {
      "authentication": "$t(common:labels.authentication)",
      "usage": "$t(common:labels.usage)",
      "authorizationRules": "Authorisation rules",
      "design": "Design",
      "vas": "VAS",
      "lifecycle": "Lifecycle",
      "feesAndCharges": "Fees and Charges",
      "settings": "Account Settings",
      "ledgers": "$t(common:labels.ledgers)"
    },
    "authorizationRules": {
      "financialSettings": "Financial Settings",
      "tokenRequest": "Token Request",
      "nonFinancial": "Non-Financial",
      "extendedService": "Extended Service",
      "cardholderNotPresent": "Cardholder Not Present",
      "chipPanEntry": "Chip PAN Entry",
      "others": "Others",
      "eCommerce": "E-Commerce",
      "reservations": "Reservations",
      "chip": "Chip",
      "magStripe": "MagStripe",
      "manualKeyEntry": "Manual Key Entry",
      "moto": "Moto",
      "recurring": "Recurring",
      "manual": "Manual",
      "accountFunding": "Account Funding",
      "returnOfGood": "Return of Good - Credit/Credit Voucher",
      "originalCredit": "Original Credit",
      "loadAndActivation": "Load and Activation",
      "adjustment": "Adjustment",
      "creditTransaction": "Credit Transaction",
      "accountVerification": "Account Verification",
      "authorizationRequest": "Authorization Request",
      "services": "$t(common:labels.services)",
      "acceptanceGroup": "Acceptance Group",
      "verificationGroup": "Verification Group",
      "purchase": "Purchase",
      "withdrawal": "Withdrawal",
      "purchaseWithCashBack": "Purchase with Cash-back",
      "purchaseReturnRefund": "Purchase Return/Refund",
      "eventNotification": "Event Notification",
      "cashDisbursement": "Cash Disbursement",
      "quasiCash": "Quasi Cash",
      "paymentTransaction": "Payment Transaction",
      "eligibilityRequest": "Eligibility Request",
      "authorisationRequest": "Authorisation Request",
      "authenticationRequest": "Authentication Request",
      "internationalAllowed": "International Allowed",
      "accountStatusNotification": "Account Status Notification",
      "activationCodeNotification": "Activation Code Notification",
      "tokenGenerationNotification": "Token Generation Notification",
      "tokenCompletionNotification": "Token Completion Notification",
      "tokenNotification": "Token Notification",
      "internationalRoaming": "International Roaming",
      "onUseBilling": "On Use Billing",
      "outsideBillingCurrency": "Outside Billing Currency",
      "balanceInquiry": "Balance Inquiry",
      "pinUnblock": "PIN Unblock",
      "pinChange": "PIN Change",
      "phoneMailOrder": "Phone / Mail Order",
      "reoccuring": "Reocurring",
      "recurringBilling": "Recurring Billing",
      "credentialOnFile": "Credential On File",
      "offlinePINVerification": "Offline PIN Verification",
      "onlinePINVerification": "Online PIN Verification",
      "signatureVerification": "Signature Verification",
      "noCVMRequired": "No CVM Required",
      "magStripePanEntry": "Mag Stripe - PAN Entry",
      "resetMethod": "Reset Method",
      "unknownAcceptance": "Unknown Acceptance Method",
      "fallbackChipToMagneticStripe": "Fallback - Chip to Magnetic Stripe",
      "manualEntryChipCapableTerminal": "Manual entry - Chip Capable Terminal",
      "expiryDateCheck": "Expiry Date Check",
      "cvcCvvCheck": "CVC/CVV Check",
      "startDateCheck": "Start Date Check",
      "avsCheck": "AVS Check",
      "digitalWmid": "Digital WMID",
      "serviceCode": "Service Code",
      "atc": "ATC",
      "cryptoArqc": "Crypto - ARQC",
      "messages": {
        "authorizationRulesUpdatedSuccessfully": "Authorization rules updated successfully."
      }
    },
    "settings": {
      "title": "Edit Pin Settings",
      "accountBalanceInquiry": "Account balance inquiry & balance type",
      "resetToDefault": "Reset to Default",
      "noApiAvailable": "The API for this action is not available yet.",
      "accountStatusInquiry": "Account status inquiry service",
      "accountNameCheck": "Account name check service",
      "ledgerMaximumBalance": "Ledger maximum balance limit check service",
      "balanceInquiry": {
        "label": "Account balance inquiry",
        "realTime": "Real Time",
        "endOfDay": "End of the Day",
        "atm": "ATM (single & dual message)",
        "description": "Manage account balance inquiry & balance type",
        "allowBalanceInquiry": "Allow account balance inquiry",
        "balanceType": "Balance Type"
      },
      "statusInquiry": {
        "description": "Manage account status inquiry service",
        "allowStatusInquiry": "Allow account status inquiry"
      },
      "nameCheck": {
        "description": "Manage account name check service",
        "allowNameCheck": "Allow name check inquiry"
      },
      "maximumBalance": {
        "description": "Manage maximum balance service",
        "allowLedgerMaximum": "Allow ledger maximum balance limit check"
      }
    },
    "authentication": {
      "pin": "PIN",
      "contactlessControls": "Contactless Settings",
      "pinControls": "PIN Controls",
      "pinRequired": "Pin required",
      "pinRequiredForTransactions": "Pin required for transactions",
      "pinTypeLength": "Pin type & max length",
      "pinTypeLevelLength": "Pin type, level & max length",
      "pinTypeLevelLengthMessage": "Select how to generate pin, pin level of and maximum pin characters",
      "pinTypeLengthMessage": "Select maximum pin characters",
      "maxIncorrectAttempts": "Maximum incorrect pin attempts before lock",
      "maxIncorrectAttemptsMessage": "Select maximum incorrect pin attempts before instrument gets locked",
      "pinCalculationMethod": "Pin calculation method",
      "pinCalculationMethodMessage": "Select pin calculation method",
      "pinStatus": "Pin status",
      "pinStatusMessage": "Select status of pin",
      "timeToWaitSsp": "Time to wait for SSP",
      "timeToWaitSspMessage": "Set time to wait for SSP",
      "pinBureau": "Pin bureau",
      "pinBureauMessage": "Select pin bureau",
      "allowPinChangeApi": "Allow pin change with API",
      "allowPinChangeApiMessage": "Allow clients or customers to change instrument pins with API",
      "allowPinOverride": "Allow pin override",
      "allowPinOverrideMessage": "Allow clients and customers to override pin",
      "configurePinMessage": "Configure PIN settings for this instrument product",
      "pinLength": "PIN Length",
      "pinType": "PIN Type",
      "pinLevel": "PIN Level",
      "decimalizationTable": "Decimalization Table",
      "padCharacter": "Pad Character",
      "configureContactlessMessage": "Configure contactless payment settings for this instrument product",
      "allowContactless": "Allow contactless transactions",
      "pinRequiredContactless": "PIN required for contactless transactions",
      "pinRequiredContactlessDesc": "Allow pin to authenticate the transaction",
      "maxLimit": "Max limit of a single contactless transaction",
      "maxLimitDesc": "Edit limit of a single contactless transaction",
      "limitReset": "Contactless limit reset triggered by",
      "limitResetDesc": "Set how contactless transaction limit reset will be triggered",
      "transactionsAllowed": "Contactless transactions allowed within a period #",
      "transactionsAllowedFrequency": "Contactless transactions allowed within a period - frequency",
      "maxAmount": "Maximum amount of accumulated contactless transactions allowed since the last authenticated card present authorization",
      "maxNumber": "Maximum number of accumulated contactless transactions allowed since the last authenticated card present authorization",
      "totalAmount": "Total Amount",
      "actionWhenContactlessLimitExceeded": "Action when contactless limit is exceeded",
      "minAmount": "Minimum amount of a contactless transaction that will not impact the accumulation values for the PAN",
      "actionWhenExceededSingleAmount": "Action when max single amount is exceeded",
      "actionWhenExceededAccumulatedAmount": "Action when max accumulated amount is exceeded",
      "actionWhenExceededAccumulatedCount": "Action when max accumulated count is exceeded",
      "transactionsAtTerminals": "Transactions at non-PIN terminals are contactless",
      "editContactlessTitle": "Edit Contactless Transaction Settings",
      "editSetting": "Edit Setting",
      "contactlessDescription": "Allow tap, wave, or hovering the card near the POC device without inserting them?",
      "editMaxLimitTitle": "Edit Contactless Limit Settings",
      "messages": {
        "confirmChangeDescription": "Are you sure you want to change {{setting}} to {{value}}?",
        "contactlessSettingUpdated": "Contactless setting updated successfully.",
        "pinSettingUpdated": "PIN setting updated successfully."
      },
      "noOfTransactions": "No. of Transactions",
      "contactlessSubTab": {
        "title": "Contactless Configuration"
      }
    },
    "usage": {
      "instrumentForm": "Instrument form type (physical/virtual)",
      "activationStatus": "Instrument activation status",
      "currencyAndCountry": "Currency And Country",
      "mccGroups": "MCC Groups",
      "limits": "$t(common:labels.limits)",
      "baseCountry": "Base Country",
      "baseCurrency": "Base Currency",
      "isoCode": "ISO Code",
      "notSupported": "Not supported",
      "domesticUsage": "Domestic Usage",
      "internationalUsage": "International Usage",
      "singlePurchase": "Single Purchase",
      "daily": "Daily",
      "weekly": "Weekly",
      "monthly": "Monthly",
      "mccLowCode": "MCC Low Code",
      "mccHighCode": "MCC High Code",
      "mccName": "MCC Name",
      "confirmChangesTitle": "Confirm changes to MCC Groups?",
      "updateSuccessMccGroups": "You have successfully made changes on selected MCC Groups",
      "updateFailedMccGroups": "Failed to update MCC Groups",
      "updateSuccessLimitGroups": "You have successfully made changes on selected Limit Groups",
      "updateFailedLimitGroups": "Failed to update Limit Groups",
      "updateFailedCurrencyCountry": "Failed to update Currency and Country settings"
    },
    "ledgerConfiguration": {
      "addLedgerConfiguration": "Add Ledger Configuration",
      "addLedger": "$t(common:labels.addLedger)",
      "addNewLedgerConfiguration": "Add New Ledger Configuration",
      "addLimit": "Add Limit",
      "ledgerName": "$t(common:labels.ledgerName)",
      "autoCreate": "Auto Create",
      "editLoadLimit": "Edit Load Limits",
      "limitType": "Limit Type",
      "maximum": "Maximum",
      "ledgerConfigurationNotFound": "Ledger configuration not found",
      "searchPlaceholder": "Search by Ledger Name or currency",
      "noLedgerConfigurations": "No Ledger Configurations found for this financial product",
      "enterLedgerName": "Enter Ledger Name",
      "selectCurrency": "Select currency",
      "pleaseEnterLedgerName": "Please enter a Ledger Name",
      "confirmChangesToLoadLimit": "Confirm changes to Load Limits",
      "confirmChangesMessage": "You are about to save load limit rules for {{name}}. These updates will affect how funds can be loaded into this ledger. Are you sure you want to continue?",
      "createLedgerConfiguration": "Create Ledger Configuration",
      "ledgerLoadLimit": "{{name}} - Load Limits",
      "updateSuccess": "Ledger updated successfully",
      "ledgerCreatedSuccess": "$t(common:labels.ledgerCreatedSuccess)",
      "ledgerCreatedError": "Failed to create ledger",
      "updateFailed": "Failed to update ledger",
      "policyGroupType": "Policy Group Type",
      "loadLimitLegacy": "Load Limits (Legacy)",
      "ledgerCreationMultiCurrency": "Ledger Creation (Multi-Currency)",
      "createNewLedger": "$t(common:labels.createNewLedger)",
      "allCurrenciesAdded": "All available currencies have been added"
    },
    "loadLimit": {
      "title": "Maximum loads and balance",
      "single": "Single",
      "annually": "Annually",
      "addNewRule": "Add New Rule",
      "addRule": "Add Rule",
      "confirmChangesTitle": "Confirm changes to Load Limits ({{count}})",
      "confirmChangesMessage": "You are about to save {{count}} load limit rule(s). These updates will affect how funds can be loaded into ledgers. Are you sure you want to continue?",
      "updateSuccess": "Load limits updated successfully",
      "updateFailed": "Failed to update load limits"
    },
    "limits": {
      "editLimitTitle": "Edit Limit",
      "minSpendTooltip": "Enter the minimum amount for this limit type",
      "maxSpendTooltip": "Enter the maximum amount for this limit type",
      "frequencyTooltip": "Number of times this limit can be used within the specified period",
      "noDomesticLimits": "You don't have any Domestic Limits in place.",
      "noInternationalLimits": "You don't have any International Limits in place.",
      "lastUpdated": "Last updated",
      "maxMustBeGreaterThanMin": "Maximum spend must be greater than minimum spend"
    },
    "createNewProduct": {
      "configureMaster": "Configure Master",
      "configureBuckets": "Configure Buckets",
      "configureInterest": "Configure Interest",
      "configureCreditDetails": "Configure Credit Details",
      "createNewProduct": "Create New Product",
      "selectSubClients": " Select Subclients",
      "activeEnd": "Active End",
      "activeStart": "Active Start",
      "clientId": "$t(common:labels.clientId)",
      "financialProduct": "Financial Product",
      "instrumentProduct": "Instrument Product",
      "binRangeId": "BIN Range ID",
      "global": "Global",
      "local": "Local",
      "unspecified": "$t(common:status.unspecified)",
      "descriptionMaxLength": "A maximum of 500 characters is allowed.",
      "statusAll": "Status: All",
      "EODProcessingAndCycling": "EOD Processing & Cycling",
      "EODProcessing": "EOD Processing",
      "paymentAllocation": "Payment Allocation",
      "cutoffHour": "Cutoff Hour",
      "accountCycling": "Account Cycling",
      "minimumPayment": "Minimum Payment",
      "limits": "$t(common:labels.limits)",
      "messages": {
        "productUpdatedSuccessfully": "Product updated successfully.",
        "productCreatedSuccessfully": "Product created successfully.",
        "productAndLedgersCreatedSuccessfully": "Financial product and ledgers created successfully.",
        "productCreationFailed": "Failed to create financial product.",
        "policyGroupCreatedSuccessfully": "Policy group created successfully.",
        "updateSuccessful": "Update successful"
      },
      "deleteBucketButton": "Delete Bucket",
      "createNewBucket": "Create a new Bucket"
    },
    "createNewClient": {
      "addNewClient": "$t(clientLifecycle:labels.addNewClient)",
      "businessRegisteredName": "Business Registered Name",
      "subClientName": "Sub Client Name",
      "baseCurrency": "$t(clientLifecycle:labels.baseCurrency)",
      "addNewPhone": "Add New Phone",
      "addNewAddress": "Add New Address",
      "invalidField": "Invalid Input",
      "parentMSAClient": "Parent MSA Client",
      "msaClient": "MSA Client",
      "contactPerson": "Contact Person",
      "sameAsMSAClient": "Same as MSA-Client",
      "differentContactDetails": "Different contact details",
      "address": "$t(common:labels.address)",
      "differentAddress": "Different Address"
    },
    "productDetails": {
      "launchDate": "Launch Date",
      "version": "Version"
    },
    "clientDetails": {
      "clientType": "Client Type",
      "closeClient": "Close Client",
      "closeNow": "Close now",
      "businessDetails": "Business Details",
      "scheme": "$t(common:components.card.scheme)",
      "apexProgrammeManager": "APEX Programme Manager",
      "apexProgrammeManagerCode": "APEX Programme Manager Code",
      "apexProgrammeManagerId": "APEX Programme Manager Id",
      "policies": "Policies",
      "onboarding": "Onboarding",
      "profileNotFinalised": "This Client profile has not been finalised",
      "completeProfile": "Complete profile",
      "noPoliciesYet": "No Policies yet",
      "noPoliciesDescription": "It looks like this client doesn't have any policies. Go ahead and add one to get started.",
      "createNewPolicy": "Create new policy",
      "messages": {
        "closeClientConfirmMSAClient": "This action will automatically close all associated sub-clients and products. This will prevent the addition of new products or sub-clients.",
        "closeClientConfirmSubClient": "You are about to close the client account. This action will automatically close all associated products and will prevent the addition of new products.",
        "clientClosedSuccessfully": "Client closed successfully.",
        "closureScheduledSuccessfully": "Client closure scheduled successfully.",
        "scheduleClosureConfirmMSAClient": "This action will schedule the client for closure. Associated sub-clients and products remain active until the closure is completed.",
        "scheduleClosureConfirmSubClient": "This action will schedule the client for closure. Associated products remain active until the closure is completed.",
        "statusChangeStandaloneTitle": "Status changes are saved on their own",
        "statusChangeStandaloneDescription": "You've selected a status change. Save the status on its own first, or set the status back to continue editing the other fields.",
        "closureDataLockedTitle": "Client closure is scheduled",
        "closureDataLockedDescription": "Data is locked while closure is scheduled. Only closing the client is available."
      },
      "authorizedContactDetails": "Authorised Contact Details",
      "journeyBanner": {
        "openMessage": "This client is being processed. Products and customers will be available once active",
        "activeSubClientMessage": "Create a financial product",
        "disabledTabTooltip": "Submit and activate this sub-division to enable product and customer configuration.",
        "activeSubClientAction": "Create product"
      }
    },
    "clientServices": {
      "sdk": "SDK",
      "sdkSettings": "SDK Settings"
    },
    "productListing": {
      "instrumentProducts": "$t(common:labels.instrumentProducts)",
      "financialProducts": "$t(common:labels.financialProducts)",
      "noFinancialProductsYet": "No financial products yet. Create your first product",
      "createFirstProduct": "Create financial product"
    },
    "generateAccountHolderId": {
      "accountHolderRulesCondiguration": "Account Holder Rules Configuration",
      "title": "Generate Account Holder ID",
      "numberGenerationSource": "Number Generation Source",
      "autoAccountHolderIds": "We'll create account holder IDs for you",
      "idAutoFormat": "Your ID will follow a standard 16-digit format.",
      "idAutoIncrement": "Each new account ID will be incremented by 1 automatically.",
      "uniqueAccount": "This keeps your account unique, consistent and easy to manage.",
      "success": "Account Holder ID created",
      "personaliseAccountHolderNumber": "I want to personalise account holder number",
      "missingClient": "You can't generate an account Id for a missing client"
    },
    "channelRules": {
      "channelRules": "Channel Rules",
      "addChannel": "Add Channel",
      "addChannelRule": "Add Channel Rules",
      "editChannelRule": "Edit Channel Rules",
      "rejectionRules": {
        "rejectAndReport": "Reject & Report",
        "rejectAndSuspend": "Reject & Suspend"
      },
      "channelTypes": {
        "customChannel": "Custom channel",
        "loadChannel": "Load channel",
        "schemeSettlementChannel": "Scheme settlement channel"
      }
    },
    "ledgerCreationWizard": {
      "saveAndContinueToInstrumentProduct": "Create and Continue to Instrument Product",
      "draftSavedSuccessfully": "Your draft has been saved successfully.",
      "errors": {
        "missingClientId": "Client ID is missing. Please go back and select a client."
      },
      "generateAccountIds": {
        "title": "Generate Account IDs",
        "createUniqueAccountIds": "Create unique Account IDs",
        "creation": "Account ID Creation",
        "generation": "Account ID Generation",
        "idLength": "ID Length",
        "rule": "Rule",
        "digits": "Digits",
        "defineDigits": "Define the digit(s) for this rule",
        "generateAccountIdsSuccess": "Account Ids generated successfully",
        "generateAccountIdsFailed": "Failed to generate Account Ids",
        "personaliseAccountIdGeneration": "I want to personalise account ID generation",
        "createCustomRulesDescription": "Define length and increment rules",
        "howToPersonaliseAccountIdGeneration": "How to Personalise Account ID Generation",
        "selectAccountIdLength": "1. Select Account ID Length",
        "chooseTotalDigits": "Choose the total number of digits for the account ID (e.g., 16 digits).",
        "createRules": "2. Create Rules",
        "defineRulesBySelectingDigits": "Define rules by selecting at least two digits per rule.",
        "allDigitsMustBeIncluded": "You can create multiple rules, but all digits must be included across your rules.",
        "exampleFor16Digits": "Example for 16 digits:",
        "rule1Digits1_4": "Rule 1 → digits 1-4",
        "rule2Digits5_10": "Rule 2 → digits 5-10",
        "rule3Digits11_16": "Rule 3 → digits 11-16",
        "selectRuleType": "3. Select RuleType",
        "selectRuleTypeMd": "Select Rule Type",
        "chooseRuleBehavior": "For each rule, choose how the number behaves:",
        "fixedBehavior": "Fixed → The digits remain constant.",
        "incrementalBehavior": "Incremental → The digits increase sequentially (by 1) each time.",
        "specifyDigitsForEachRule": "4. Specify Digits for Each Rule",
        "digitsForThisRule": "Digits for this rule",
        "defineDigitsForEachRule": "Define digit(s) for this rule",
        "selectSpecificDigits": "Based on the number of digits in each rule, select the specific digits you want to include.",
        "enterStartingNumber": "Enter Starting Number",
        "enterStartingNumberDescription": "Enter the number for the sequence to start from. It must be {{count}} digits or less.",
        "exampleRule1": "Example: For Rule 1 (digits 1-4), choose four digits you want in this section e.g. 7777.",
        "accountNumberIdLength": "Account Number ID Length",
        "selectDigitPositions": "Select digit positions to create rules",
        "clearRules": "Clear Rules",
        "selected": "Selected",
        "coveredByRule": "Covered by rule",
        "positionTooltip": "Position {{position}} - {{ruleType}} rule",
        "positionTooltipClickToSelect": "Position {{position}} - Click to select",
        "rules": "Rules",
        "pleaseCreateRulesForAllDigits": "Please create rules for all digits available",
        "allDigitsRequireRules": "All digits require rules.",
        "whatKindOfRule": "What kind of rule do you want to set up?",
        "uncoveredPositions": "Uncovered positions: {{uncoveredPositions}}",
        "configurationError": "Configuration Error",
        "createRule": "Create Rule",
        "validation": {
          "atLeastOneRule": "At least one rule is required",
          "rulesOverlap": "Rules overlap: Rule {{rule1}} ({{range1}}) overlaps with Rule {{rule2}} ({{range2}})",
          "uncoveredPositions": "Uncovered positions: {{positions}}. All positions must be covered by rules.",
          "fixedRuleMustHaveValue": "Fixed rule for positions {{range}} must have a value",
          "fixedRuleValueLengthMismatch": "Fixed rule value \"{{value}}\" length ({{valueLength}}) must match rule length ({{ruleLength}})",
          "fixedRuleValueMustBeDigits": "Fixed rule value \"{{value}}\" must contain only digits",
          "incrementalRuleMustHavePositiveIncrement": "Incremental rule for positions {{range}} must have a positive increment value",
          "startPositionOutOfBounds": "Rule start position {{position}} is out of bounds (1-{{totalLength}})",
          "endPositionOutOfBounds": "Rule end position {{position}} is out of bounds (1-{{totalLength}})",
          "startPositionGreaterThanEndPosition": "Rule start position {{start}} cannot be greater than end position {{end}}"
        },
        "deleteRule": "Delete Rule",
        "deleteRuleConfirmation": "Are you sure you want to delete the rule for positions",
        "editRule": "Edit Rule",
        "editingRule": "Editing rule for positions",
        "editFunctionalityNotYetImplemented": "Edit functionality not yet implemented",
        "fixed": "Fixed",
        "incremental": "Incremental",
        "auto": "Auto",
        "mixed": "Mixed",
        "weWillCreateAccountIds": "We will create account IDs for you",
        "standardFormat": "Your IDs will follow a standard 16-digit format.",
        "uniqueAccountNumbers": "This keeps your account IDs unique, consistent, and easy to manage.",
        "personalised": "Personalised",
        "popover": {
          "description": "Select how to generate your unique Account IDs.",
          "standardDesc": "16 digits that auto-increment",
          "personalisedDesc": "incorporate static digits to identify different products"
        }
      },
      "productDetails": {
        "title": "$t(common:labels.basicInformation)",
        "subtitle": "Give product a name and select the client to get started",
        "clientLabel": "Which client will own this product?"
      },
      "subtitle": "Create ledgers to manage funds for each currency",
      "stepper": {
        "productDetails": "Debit Product Details",
        "productConfiguration": "Product Configuration",
        "accountIds": "Account IDs",
        "linkApexCard": "Link APEX Card",
        "linkLedgers": "Link Ledgers",
        "linkInstrument": "$t(clientLifecycle:components.ledgerCreationWizard.linkInstrument.title)"
      },
      "steps": {
        "currencyDescription": "Select the currency for your ledger",
        "nameDescription": "Configure the ledger name",
        "limitsDescription": "Set load limits for the ledger",
        "combinedDescription": "Configure currency, name and limits for each ledger",
        "addLedgerFirst": "Add a ledger first to configure it"
      },
      "currency": {
        "alertMessage": "You have to create at least one Ledger",
        "addLedger": "$t(common:labels.addLedger)",
        "searchPlaceholder": "Search currencies",
        "ledgerTitle": "{{currency}} Ledger",
        "ledgerTitleWithName": "{{currency}} Ledger - {{name}}"
      },
      "instrumentProduct": {
        "allocateLabel": "Do you want to select Instrument Products to be allocated to this ledger?",
        "selectLabel": "Select Instrument Products to be allocated to this ledger",
        "inputPlaceholder": "Input Instrument Product name"
      },
      "name": {
        "ledgerNameLabel": "Ledger Name (optional)",
        "inputPlaceholder": "Input name",
        "helperText": "Keep the suggested ledger name or create your preferred name.",
        "creationMethodTitle": "How do you want the ledger to be created?",
        "automaticOption": "Automatic"
      },
      "limits": {
        "description": "Do you want to set limits for this ledger?"
      },
      "cutoff": {
        "description": "Do you want to set cut-off periods for this ledger?"
      },
      "ledgersSummary": {
        "title": "Ledgers to Create",
        "existing": "Existing",
        "limitsConfigured": "Configured",
        "limitsNotConfigured": "Not configured"
      },
      "manageLedgers": {
        "title": "Manage Ledgers",
        "selectedCount": "{{count}} of {{total}} selected",
        "noLedgersFound": "No ledgers found",
        "editLedger": "Edit Ledger",
        "updateCurrency": "Update the currency for this ledger configuration."
      },
      "ledgerSelector": {
        "instrumentProductsAllocated": "Instrument Products allocated",
        "maximumLimits": "Maximum Limits",
        "noLimits": "No limits",
        "noLedgersSelected": "No ledgers selected"
      },
      "linkInstrument": {
        "title": "Link Instrument",
        "subtitle": "Link Instrument and connect it to Ledgers",
        "question": "Would you like to link an Instrument to this Product?",
        "noInstrumentsMessage": "This client doesn't have any Instruments.",
        "noInstrumentsDescription": "You can create an Instrument separately in the Instruments section at any time. If you're not ready to add one now, you can continue to the Review & Finish step and add an Instrument later when it's ready.",
        "instrumentsLabel": "Instrument(s)",
        "selectInstrumentsPlaceholder": "Select Instrument(s)",
        "ledgersLabel": "Ledgers(s)",
        "selectLedgersPlaceholder": "Select Ledger(s)"
      }
    }
  },
  "mccCodeMaster": {
    "mccCodeMaster": "MCC Code Master",
    "mccCodeDescription": "MCC Code Description"
  },
  "currencyMaster": {
    "currencyMaster": "Currency Master",
    "exponent": "Exponent",
    "visaExponent": "Visa Exponent"
  },
  "loadSourceMaster": {
    "loadSourceMaster": "Load Source Master",
    "loadSource": "Load Source"
  },
  "groupLimitMaster": {
    "groupLimitMaster": "Group Limit Master",
    "groupLimitCode": "Group Limit Code",
    "periodicity": "Periodicity"
  },
  "groupLimit": {
    "process": "Process",
    "maxPerTran": "Maximum per Transaction",
    "minPerTran": "Minimum per Transaction",
    "dailyFreq": "Daily Frequency",
    "accumLimit1": "Accumulation Limit 1",
    "accumFreq1": "Accumulation Frequency 1",
    "accumPeriod1": "Accumulation Period 1",
    "accumLimit2": "Accumulation Limit 2",
    "accumFreq2": "Accumulation Frequency 2",
    "accumPeriod2": "Accumulation Period 2",
    "maxBalance": "Max Balance",
    "maxBalanceTooltip": "The following limits are denominated in the billing currency of the card to which they apply. To omit the limit enter 0."
  },
  "mccGroupMaster": {
    "mccGroupMaster": "MCC Group Master",
    "groupMccCode": "Group MCC Code"
  },
  "mccGroup": {
    "groupMccSettings": "Group MCC Settings",
    "mccGroup": "MCC Group",
    "addNewMccCode": "Add New MCC Code",
    "disallow": "Disallow",
    "mccGroupHistory": "MCC Group History"
  },
  "usageGroupMaster": {
    "usageGroupMaster": "Usage Group Master"
  },
  "usageGroupRulesDetails": {
    "usageGroupRulesDetails": "Usage Group Rules Details",
    "checkGroupsThatApply": "Tick a box to Allow the usage",
    "cardAcceptanceMethod": "Card Acceptance Method (A)",
    "transactionType": "Transaction Type (T)",
    "verificationChecks": "Verification Checks (V)",
    "misc": "Misc (M)"
  },
  "groupCardLinkage": {
    "groupCardLinkage": "Group Card Linkage",
    "groupLinkageCode": "Group Linkage Code",
    "singleTransferMaxLimit": "Single Transfer Max Limit",
    "dailyTransferMaxLimit": "Daily Transfer Max Limit",
    "overnightSweepOfFunds": "Overnight Sweep Of Funds",
    "shareLimitsWithPrimary": "Share Limits With Primary",
    "auths": "Auths",
    "loads": "Loads",
    "onSecondary": "On Secondary",
    "unlimitedTransferJamJars": "Unlimited Transfer Between JamJars",
    "primaryBalance": "Primary Balance"
  },
  "cardAcceptorList": {
    "cardAcceptorListMaster": "Card Acceptor List Master",
    "cardDisallowListMaster": "Card Disallow List Master",
    "cardAcceptorName": "Card Acceptor Name",
    "cardAcceptorListCardAcceptor": "Card Acceptor List - Card Acceptor",
    "cardDisallowListCardAcceptor": "Card Disallow List - Card Acceptor",
    "cardAcceptorId": "Card Acceptor ID",
    "cardDisallowListName": "Card Disallow List Name"
  }
}
